import { render, staticRenderFns } from "./FormSelectField.vue?vue&type=template&id=2541984b&scoped=true"
import script from "./FormSelectField.vue?vue&type=script&lang=js"
export * from "./FormSelectField.vue?vue&type=script&lang=js"
import style0 from "./FormSelectField.vue?vue&type=style&index=0&id=2541984b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2541984b",
  null
  
)

export default component.exports